<template>
  <main id="main-content" aria-hidden="true"></main>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const auth = useAuthStore()
const router = useRouter()

onMounted(async () => {
  try {
    await fetch('/api/v1/auth/logout', {
      method: 'POST',
      credentials: 'same-origin',
    })
  } catch {
    // Local auth state still needs to be cleared if the network request fails.
  }
  auth.clearTokens()
  await router.replace('/login')
})
</script>
